import { Routes } from '@angular/router';
import { authGuardGuard } from './auth/auth-guard.guard';

import { SignInComponent } from './user/sign-in/sign-in.component';
import { UserComponent } from './user/user.component';
import { GameListComponent } from './game/game-list/game-list.component';
import { HomeComponent } from './home/home.component';

import { ScheduleMonthComponent } from './schedule/screens/schedule-month/schedule-month.component';
import { ScoutingFlowComponent } from './scouting/screens/scouting-flow/scouting-flow.component';
import { PlayerDetailsComponent } from './scouting/screens/player-details/player-details.component';
import { UserProfileComponent } from './user/screens/user-profile/user-profile.component';
import { RankingListsComponent } from './lists/screens/ranking-lists/ranking-lists.component';
import { RankingListComponent } from './lists/screens/ranking-list/ranking-list.component';
import { GameDetailsComponent } from './game/screens/game-details/game-details.component';
import { ScheduleViewModel } from './shared/models/ScheduleModels';
import { ScheduleViewComponent } from './schedule/screens/schedule-view/schedule-view.component';
import { NewReportComponent } from './scouting/screens/new-report/new-report.component';
import { NewNoteComponent } from './scouting/screens/new-note/new-note.component';
import { EditReportComponent } from './scouting/screens/edit-report/edit-report.component';
import { NewListComponent } from './lists/screens/new-list/new-list.component';
import { SearchComponent } from './search/screens/search/search.component';
import { RankingListEditComponent } from './lists/screens/ranking-list-edit/ranking-list-edit.component';
import { ScheduleComingComponent } from './schedule/screens/schedule-coming/schedule-coming.component';
import { PlayerSearchComponent } from './search/screens/player-search/player-search.component';
import { ScheduleWeekComponent } from './schedule/screens/schedule-week/schedule-week.component';
import { ScheduleMonthSmallComponent } from './schedule/screens/schedule-month-small/schedule-month-small.component';
import { ScoutingFlowTightComponent } from './scouting/screens/scouting-flow-tight/scouting-flow-tight.component';
import { ReportDetailsComponent } from './scouting/screens/report-details/report-details.component';
import { GameList2Component } from './game/screens/game-list2/game-list2.component';
import { ResetPasswordComponent } from './user/screens/reset-password/reset-password.component';
import { GameList3Component } from './game/screens/game-list3/game-list3.component';
import { TeamDetailsComponent } from './game/screens/team-details/team-details.component';
import { ReportSearchComponent } from './search/screens/report-search/report-search.component';
import { FavoritePlayersComponent } from './search/screens/favorite-players/favorite-players.component';
import { FavouritePlayersComponent } from './search/screens/favourite-players/favourite-players.component';
import { PlayersByTagComponent } from './search/screens/players-by-tag/players-by-tag.component';
import { TagsComponent } from './scouting/screens/tags/tags.component';
import { AppColorsComponent } from './admin/screens/settings/app-colors/app-colors.component';
import { SettingsComponent } from './admin/screens/settings/settings.component';
import { ScoutsComponent } from './admin/screens/scouts/scouts.component';
import { ScoutDetailsComponent } from './admin/screens/scout-details/scout-details.component';
import { ConfigUserDetailsComponent } from './user/config-user-details/config-user-details.component';
import { NewScoutComponent } from './admin/screens/new-scout/new-scout.component';





export const routes: Routes = [
    { 
    path: '',
       redirectTo: '/login',
       pathMatch: 'full'
       },
    //USER
    {
        path: 'userprofile', component: UserProfileComponent, canActivate: [authGuardGuard], data: {roles: ['Scouting_Scout', 'Scouting_Admin']}      
    }, 
    {
        path: '', component: UserComponent,
        children: [{ path: 'login', component: SignInComponent }]
    },
   /*  {
        path: 'login', component: UserComponent,
       // children: [{ path: 'login', component: SignInComponent }]
    }, */
    {
        path: 'resetpassword', component: ResetPasswordComponent

    }, 
 /*    {
        path: '', component: SignInComponent, canActivate: [authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
       
    }, */
    //GENERAL
    {
        path: 'home', component: HomeComponent, canActivate: [authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}       
       
    },
    //GAMES
    {
        path: 'games', component: GameListComponent, canActivate: [authGuardGuard], data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
       
    },
    {
        path: 'games2', component: GameList2Component, canActivate: [authGuardGuard], data: {roles: ['Scouting_Scout', 'Scouting_Admin']}

    },
    {
        path: 'games3', component: GameList3Component, canActivate: [authGuardGuard], data: {roles: ['Scouting_Scout', 'Scouting_Admin']}

    }, 
    {
        path: 'games/:GameId', component: GameDetailsComponent, canActivate: [authGuardGuard], data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
       
    }, 
    //SCOUTING
    {
        path: 'scouting', component: ScoutingFlowComponent, canActivate: [authGuardGuard],
        data: {roles: ['Scouting_Scout', 'Scouting_Admin']}

    },
    {
        path: 'scouting_2', component: ScoutingFlowTightComponent, canActivate: [authGuardGuard],
        data: {roles: ['Scouting_Scout', 'Scouting_Admin']}

    }, 
    {
        path: 'scouting/game/:GameId', component: GameDetailsComponent, canActivate: [authGuardGuard],
        data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    }, 
    { path: 'scouting/gamedetails', redirectTo: 'scouting', pathMatch: 'full' },
    {
        path: 'scouting/gamedetails/:GameId', component: GameDetailsComponent, canActivate: [authGuardGuard],
        data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    }, 
    {
        path: 'scouting/newreport/:PlayerId', component: NewReportComponent, canActivate:[authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    },
/*     {
        path: 'scouting/editreport/:ReportId', component: EditReportComponent, canActivate:[authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    }, */
    {
        path: 'scouting/newreport/:PlayerId/:GameId', component: NewReportComponent, canActivate:[authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    },
    {
        path: 'scouting/report/:ReportId', component: ReportDetailsComponent, canActivate: [authGuardGuard], data: { roles: ['Scouting_Scout', 'Scouting_Admin'] }
    },
    {
        path: 'scouting/editreport/:ReportId', component: EditReportComponent, canActivate:[authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    },
    {
        path: 'scouting/newnote/:PlayerId', component: NewNoteComponent, canActivate:[authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    },
    {
        path: 'scouting/editnote/:NoteId', component: NewNoteComponent, canActivate:[authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    },
    {
        path: 'scouting/newnote/:PlayerId/:GameId', component: NewNoteComponent, canActivate:[authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    },

    //RANKINGLISTS
    {
        path: 'lists', component: RankingListsComponent, canActivate: [authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
       
    },
    { path: 'lists/details', redirectTo: 'lists', pathMatch: 'full' }, 
    {
        path: 'lists/details/:ListId', component: RankingListComponent,canActivate:[authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    }, 
    {
        path: 'lists/new', component: NewListComponent,canActivate:[authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    }, 
    {
        path: 'lists/edit/:ListId', component: RankingListEditComponent, canActivate: [authGuardGuard], data: { roles: ['Scouting_Scout', 'Scouting_Admin'] }
    }, 
    { path: 'lists/player', redirectTo: 'lists', pathMatch: 'full' }, //Just so we can go "back" with angular router
    {
        path: 'lists/player/:PlayerId', component: PlayerDetailsComponent,canActivate:[authGuardGuard],data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    }, 
    //SCHEDULE
    {
        path: 'schedule',
        component: ScheduleViewComponent,
        canActivate: [authGuardGuard],
        children: [
            {
                path: '',
                component: ScheduleMonthSmallComponent,
                canActivate: [authGuardGuard],
                data: {roles: ['Scouting_Scout', 'Scouting_Admin']},
                outlet: 'schedule'
            },
            {
                path: 'coming', component: ScheduleComingComponent,
                canActivate: [authGuardGuard],
                data: {roles: ['Scouting_Scout', 'Scouting_Admin']},
                outlet: 'schedule'
            }, 
            {
                path: 'month', component: ScheduleMonthComponent,
                canActivate: [authGuardGuard],
                data: {roles: ['Scouting_Scout', 'Scouting_Admin']},
                outlet: 'schedule'
            },
            {
                path: 'month-small', component: ScheduleMonthSmallComponent,
                canActivate: [authGuardGuard],
                data: {roles: ['Scouting_Scout', 'Scouting_Admin']},
                outlet: 'schedule'
            },
            {
                path: 'week', component: ScheduleWeekComponent,
                canActivate: [authGuardGuard],
                data: {roles: ['Scouting_Scout', 'Scouting_Admin']},
                outlet: 'schedule'
            },

        ],
    }, 

    //PLAYER
    {
        path: 'player/details/:PlayerId', component: PlayerDetailsComponent, canActivate: [authGuardGuard],   data: {roles: ['Scouting_Scout', 'Scouting_Admin']}     
    }, 

    //Search
    {
        path: 'search', component: SearchComponent, canActivate: [authGuardGuard],  data: {roles: ['Scouting_Scout', 'Scouting_Admin']}      
    }, 
    {
        path: 'search/player', component: PlayerSearchComponent, canActivate: [authGuardGuard],        data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    }, 
    {
        path: 'search/report', component: ReportSearchComponent, canActivate: [authGuardGuard],  data: {roles: ['Scouting_Scout', 'Scouting_Admin']}      
    }, 
    {
        path: 'search/favourites', component: FavouritePlayersComponent, canActivate: [authGuardGuard], data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    },
    {
        path: 'search/favorites', component: FavoritePlayersComponent, canActivate: [authGuardGuard], data: {roles: ['Scouting_Scout', 'Scouting_Admin']}
    },
    {
        path: 'search/tags', component: PlayersByTagComponent, canActivate: [authGuardGuard], data: {roles: ['Scouting_Admin']}
    },

    {
        path: 'admin/settings', component: SettingsComponent, canActivate: [authGuardGuard], data: { roles: ['Scouting_Admin'] }
    },
    {
        path: 'admin/tags', component: TagsComponent, canActivate: [authGuardGuard], data: { roles: ['Scouting_Admin'] }
    },
    {
        path: 'admin/app-colors', component: AppColorsComponent, canActivate: [authGuardGuard], data: { roles: ['Scouting_Admin'] }
    },
    {
        path: 'admin/scouts', component: ScoutsComponent, canActivate: [authGuardGuard], data: { roles: ['Scouting_Admin'] }
    },
    {
        path: 'admin/scouts/new', component: NewScoutComponent, canActivate: [authGuardGuard], data: { roles: ['Scouting_Admin'] }
    },
    {
        path: 'admin/scouts/:UserId', component: ScoutDetailsComponent, canActivate: [authGuardGuard], data: { roles: ['Scouting_Admin'] }
    },
     {
        path: 'admin/users/:UserId', component: ConfigUserDetailsComponent, canActivate: [authGuardGuard], data: { roles: ['Scouting_Admin'] }
    },

     {
        path: 'team/details/:TeamId', component: TeamDetailsComponent, canActivate: [authGuardGuard],       
    }, 

   
];
